import {
  BusinessProcessType, cvc, ImportBPType, PayloadBPType, PayloadDeleteBPType, PayloadDetailType, PayloadGetProcessType, PayloadGetWlaTemplate,
  PayloadImportProcessBoard,
  PayloadMoveBPType,
  PayloadMutationProcessType,
  PayloadWLASubmitType,
  ResponseMutationProcessType,
  WorkloadStandartType,
} from 'components/types/businessProcess';
import {
  ApqcItem, APQCLibraryType, APQCTemplateType, PayloadAPQCLibraryType, PayloadAPQCTemplateType,
  PayloadAPQCType,
} from 'components/types/businessProcess/apqc';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

export const apiProcess = {
  treeViewList: 'process/tree-view',
  CVCList: 'process/company-value-chain',
  hierarchyList: 'process/hierarchy',
  apqcVersionList: 'process/list-apqc-version',
  apqcLibraryList: 'process/list-apqc-library',
  apqcTemplateList: 'process/list-apqc-template',
  detailProcess: 'process/detail',
  createProcess: 'process/create',
  updateProcess: 'process/update',
  deleteProcess: 'process/delete',
  createTreeProcess: 'process/add-tree',
  createChildProcess: 'process/create-child',
  createAPQC: 'process/add-apqc',
  moveProcess: 'process/move-tree',
  wlaTemplateList: 'wla-template/list',
  wlaTemplateSubmit: 'wla-template/submit',
  importProcess: 'process/import',
  importProcessBoard: 'process/import-from-another-board',
};

export const processService = {
  getTreeViewList: async (payload: PayloadGetProcessType): Promise<BusinessProcessType[]> => {
    const response = await http.post(`${URL_V2}${apiProcess.treeViewList}`, payload);
    const safeData = Array.isArray(response?.data?.data) ? response?.data?.data : [];

    return safeData;
  },

  getCVCList: async (payload: PayloadGetProcessType): Promise<cvc[]> => {
    const response = await http.post(`${URL}${apiProcess.CVCList}`, payload);

    return response.data?.data ?? response.data;
  },

  getHierarchy: async () => {
    const response = await http.post(`${URL}${apiProcess.hierarchyList}`);

    return response.data?.data ?? response.data;
  },

  getApqcVersion: async (): Promise<ApqcItem[]> => {
    const response = await http.post(`${URL}${apiProcess.apqcVersionList}`);

    return response.data?.data ?? response.data;
  },

  getApqcLibrary: async (payload: PayloadAPQCLibraryType): Promise<APQCLibraryType[]> => {
    const response = await http.post(`${URL}${apiProcess.apqcLibraryList}`, payload);

    return response.data?.data ?? response.data;
  },

  getApqcTemplate: async (payload: PayloadAPQCTemplateType): Promise<APQCTemplateType[]> => {
    const response = await http.post(`${URL}${apiProcess.apqcTemplateList}`, payload);

    return response.data?.data ?? response.data;
  },

  getWlaTemplateList: async (payload: PayloadGetWlaTemplate): Promise<WorkloadStandartType[]> => {
    const response = await http.post(`${URL}${apiProcess.wlaTemplateList}`, payload);

    return response.data?.data ?? response.data;
  },

  detailProcess: async (payload: PayloadDetailType): Promise<BusinessProcessType> => {
    const response = await http.post(`${URL}${apiProcess.detailProcess}`, payload);

    return response.data?.data ?? response.data;
  },

  wlaTemplateSubmit: async (payload: PayloadWLASubmitType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.wlaTemplateSubmit}`, payload);

    return response.data;
  },

  createProcess: async (payload:PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.createProcess}`, payload);

    return response.data;
  },

  createTreeProcess: async (payload:PayloadMutationProcessType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.createTreeProcess}`, payload);

    return response.data;
  },

  createChildProcess: async (payload: PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.createChildProcess}`, payload);

    return response.data;
  },

  updateProcess: async (payload: PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.updateProcess}`, payload);

    return response.data;
  },

  deleteProcess: async (payload: PayloadDeleteBPType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.deleteProcess}`, payload);

    return response.data;
  },

  createAPQC: async (payload: PayloadAPQCType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.createAPQC}`, payload);

    return response.data;
  },

  moveProcess: async (payload:PayloadMoveBPType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.moveProcess}`, payload);

    return response.data;
  },

  importProcess: async (payload: ImportBPType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.importProcess}`, payload);

    return response.data;
  },

  importProcessBoard: async (payload: PayloadImportProcessBoard):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.importProcessBoard}`, payload);

    return response.data;
  },
};
